
export abstract class IGrpdPService {
    public abstract IsAccepted():Promise<boolean>;
    public abstract Accept():void;
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/infrastructure/privacy-policy/IGrpdPService.ts